"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pinToConstraintPropType = exports.autoPlacementPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PlacementConstants = require("../PlacementConstants");

var autoPlacementPropType = _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(['horiz', 'vert'])]);

exports.autoPlacementPropType = autoPlacementPropType;

var pinToConstraintPropType = _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.arrayOf(_propTypes.default.oneOf(_PlacementConstants.PLACEMENTS_SIDES))]);

exports.pinToConstraintPropType = pinToConstraintPropType;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/tooltip/utils/propTypes.js
// module id = 349
// module chunks = 209 210 211 212